import "./PalletCheck.scss";

import React from "react";
import { inject, observer } from "mobx-react";
import { RouteNode } from "react-router5";

import Frame from "../Frame/Frame";
import Popup from "../../Components/Popup/Popup";
import Button from "../../Components/Button/Button";

import { STORE_CONFIG } from "../../Store/ConfigStore";
import { ROUTE_PALLET_CHECK, ROUTE_PALLET_CHECK_DETAILS } from "../../routes";
import { STORE_PALLET_CHECK } from "../../Store/PalletCheckStore";
import { STORE_AUTH } from "../../Store/AuthStore";

import DatePicker, { registerLocale } from "react-datepicker";
import hu from "date-fns/locale/hu";
registerLocale("hu", hu);

import XLSX from "xlsx";

import {
  formatDate,
  formatDateOnly,
  fixFloat,
  formatNumber,
} from "../../utility";

import Select from "react-select";
import { SelectStyle, DropdownIndicator } from "../App/select_style";
import PalletCheckMap from "./PalletCheckMap";

const formatDistance = (pallet) => {
  if (!pallet.AutoLine || !pallet.ManualLine) return "–";
  if (/ALAP/.test(pallet.BinCode || "")) return "ALAP-ra könyvelve, nem mérhető";
  if (pallet.Distance === null || pallet.Distance === undefined)
    return "Másik folyosón / raktárban";
  return (pallet.Distance / 100).toFixed(2) + " m";
};

@inject((stores) => ({
  store: stores.store.get(STORE_PALLET_CHECK),
  configStore: stores.store.get(STORE_CONFIG),
  authStore: stores.store.get(STORE_AUTH),
  socket: stores.socket,
  router: stores.router,
}))
@observer
class PalletCheckDetails extends React.Component {
  constructor(props) {
    super(props);

    const pallet = props.store.selectedPallet;
    const bin = props.configStore.bins.find((b) => b.name === pallet.BinCode);

    this.state = {
      popup: "none",
      popupText: "",
      itemselector: false,
      addressselector: null,
      saving: false,
      bin: bin ? { value: bin.id, label: bin.name } : null,
      level: pallet.Level,
      palletId: pallet.Id,
      suggestedBins: [],
      map: null,
    };

    const _this = this;
    props.socket.emitWithToken("GetMap", {}, function (err, data) {
      if (err) {
        console.error(err);
        return;
      }
      _this.setState({ map: data });
    });
    props.socket.emitWithToken(
      "GetPalletBinRecommendations",
      { PalletId: pallet.Id },
      function (err, data) {
        if (err) {
          console.error(err);
          return;
        }
        _this.setState({ suggestedBins: data });
      }
    );
  }

  componentDidMount() {
    const { route, store } = this.props;
    if (route.params.hasOwnProperty("editedId")) {
      store.setEditedId(route.params.editedId);
    }
  }

  showPopup = (text) => {
    this.setState({ popup: "result", popupText: text });
  };

  save = () => {
    const { store, socket, router } = this.props;

    const _this = this;
    this.setState({ saving: true });
    socket.emitWithToken(
      "CheckPallet",
      {
        PalletId: this.state.palletId,
        BinId: this.state.newbin,
        Level: this.state.newlevel,
      },
      function (err, data) {
        if (err) {
          console.error(err);
          _this.showPopup(err);
          _this.setState({ saving: false });
        } else {
          router.navigate(ROUTE_PALLET_CHECK, { back: true });
          store.setSelectedPalletId(null);
        }
      }
    );
  };

  back = () => {
    const { store, router } = this.props;
    store.setSelectedPalletId(null);
    router.navigate(ROUTE_PALLET_CHECK, { back: true });
  };

  setBin = (binOption, level) => {
    const { configStore } = this.props;

    let bin = configStore.bins.find((b) => b.id == binOption.value);
    let levels = null;

    if (bin && bin.levelnum && bin.levelnum > 1) {
      levels = [];
      for (let i = 0; i < bin.levelnum; i++) {
        levels.push({ value: i, label: i });
      }
    }

    this.setState({
      bin: binOption,
      level: null,
      levels: levels,
      newbin: bin.id,
      level: level >= 0 ? { value: level, label: level } : null,
      newlevel: level,
    });
  };

  render() {
    const { store, configStore, authStore, route, router, socket } = this.props;
    const pallet = store.selectedPallet;
    const measuredBins = [pallet.AutoBin, pallet.AutoBin2].filter(
      (bin) => bin && bin.Code
    );

    let bin = this.state.bin;
    let levels = null;
    if (bin && bin.levelnum > 1) {
      levels = [];
      for (let i = 0; i < bin.levelnum; i++) {
        levels.push({ value: i, label: i });
      }
      //this.setState({ levels: levels });
    }

    return (
      <Frame>
        <div className="table basic-content">
          <div className="table__top">
            <div className="table__top-backpanel">
              <Button className="task__editbutton" onClick={() => this.back()}>
                Vissza
              </Button>
              <div className="table__top-pagename">
                {(store.type === "raw" ? "Nyers" : "Feldolgozott") +
                  " áru minőség részletek"}
              </div>
            </div>

            <div className="table__top-backpanel">
              {
                <Button
                  className="task__editbutton"
                  disabled={this.state.saving}
                  onClick={() => this.save()}
                >
                  Ellenőrzés véglegesítése
                </Button>
              }
            </div>
          </div>
          <div className="masterdata_form_frame">
            <div className="masterdata_form">
              <div className="formfield">
                <div className="formfield_label">Azonosító</div>
                <div className="formfield_input">
                  <span className="formfield_input-label">
                    <span
                      className={
                        (pallet.CleaningCount > 1 ? "bold" : "normal") +
                        (!pallet.ThisSeason ? " offseasonpallet" : "")
                      }
                    >
                      {pallet.LotNo}
                    </span>
                    {pallet.SealNum ? <br /> : null}{" "}
                    {pallet.SealNum ? "(" + pallet.SealNum + ")" : ""}
                  </span>
                </div>
              </div>
              <div className="formfield">
                <div className="formfield_label">Gép</div>
                <div className="formfield_input">
                  <span className="formfield_input-label">
                    {pallet.MachineText} {pallet.Dressing ? <br /> : null}{" "}
                    {pallet.Dressing ? "(" + pallet.Dressing + ")" : null}
                  </span>
                </div>
              </div>
              <div className="formfield">
                <div className="formfield_label">Fok</div>
                <div className="formfield_input">
                  <span className="formfield_input-label">
                    {pallet.CleaningRateText +
                      (pallet.CustomCleaningRate
                        ? " (" + pallet.CustomCleaningRate + ")"
                        : "")}
                  </span>
                </div>
              </div>
              <div className="formfield">
                <div className="formfield_label">Felhasználó</div>
                <div className="formfield_input">
                  <span className="formfield_input-label">
                    {pallet.UserName}
                  </span>
                </div>
              </div>
              <div className="formfield">
                <div className="formfield_label">Cikk</div>
                <div className="formfield_input">
                  <span className="formfield_input-label">
                    {pallet.ItemName} {pallet.CustomItem ? <br /> : null}{" "}
                    {pallet.CustomItem ? "(" + pallet.CustomItem + ")" : ""}
                  </span>
                </div>
              </div>
              <div className="formfield">
                <div className="formfield_label">Könyvelt hely</div>
                <div className="formfield_input checkdetails-selects">
                  <Select
                    className="react-select select-wide-dropdown checkdetails-select"
                    options={configStore.bins.map((bin) => ({
                      value: bin.id,
                      label: bin.name,
                    }))}
                    onChange={(e) => {
                      this.setBin(e);
                    }}
                    value={this.state.bin}
                    isSearchable={true}
                    styles={SelectStyle}
                    components={{ DropdownIndicator }}
                    placeholder="Könyvelt hely"
                  />
                  {(this.state.levels ||
                    (this.state.levels === undefined && levels)) && (
                    <Select
                      className="react-select checkdetails-select-levels"
                      options={
                        this.state.levels === undefined
                          ? levels
                          : this.state.levels
                      }
                      onChange={(e) => this.setState({ level: e, newlevel: e })}
                      value={this.state.levels ? this.state.level : null}
                      isSearchable={false}
                      styles={SelectStyle}
                      components={{ DropdownIndicator }}
                      placeholder="Szint"
                    />
                  )}
                </div>
              </div>
              <div className="formfield">
                <div className="formfield_label">Mennyiség</div>
                <div className="formfield_input">
                  <span className="formfield_input-label">
                    {(pallet.BagType === 2
                      ? pallet.BagCount + " x " + pallet.Quantity
                      : pallet.Quantity) + " kg"}
                  </span>
                </div>
              </div>
              <div className="formfield">
                <div className="formfield_label">Létrehozva</div>
                <div className="formfield_input">
                  <span className="formfield_input-label">
                    {pallet.Created}
                  </span>
                </div>
              </div>
              <div className="formfield">
                <div className="formfield_label">Incidens típus</div>
                <div className="formfield_input">
                  <span className="formfield_input-label">
                    {pallet.TypeName}
                  </span>
                </div>
              </div>
              <div className="formfield">
                <div className="formfield_label">Állapot</div>
                <div className="formfield_input">
                  <span className="formfield_input-label">
                    {pallet.Checked}
                  </span>
                </div>
              </div>
            </div>

            <div className="masterdata_form">
              <div className="formfield">
                <div className="formfield_label">Javasolt tárhelyek</div>
              </div>

              <div className="formfield">
                <div className="formfield_label">Mért hely(ek)</div>
                <div className="formfield_input">
                  {measuredBins.map((bin) => (
                    <div key={bin.Id}>
                      <span
                        className="formfield_input-label chekpallet_selectbin"
                        onClick={() =>
                          this.setBin({
                            value: bin.Id,
                            label: bin.Code,
                          })
                        }
                      >
                        {bin.Code}
                      </span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="formfield">
                <div className="formfield_label">Cikk tárhelyei</div>

                <div className="formfield_input">
                  {this.state.suggestedBins.map((bin) => (
                    <span
                      className="formfield_input-label chekpallet_selectbin"
                      onClick={() =>
                        this.setBin(
                          { value: bin.BinId, label: bin.BinName },
                          bin.Level
                        )
                      }
                    >
                      {bin.BinCode}
                    </span>
                  ))}
                </div>
              </div>
            </div>

            <div className="masterdata_form palletcheck-mapcol">
              <div className="formfield">
                <div className="formfield_label">
                  Könyvelt és mért pozíció távolsága
                </div>
                <div className="formfield_input">
                  <span className="formfield_input-label palletcheck-distance">
                    {formatDistance(pallet)}
                  </span>
                </div>
              </div>
              <PalletCheckMap map={this.state.map} pallet={pallet} />
            </div>
          </div>
        </div>

        {(this.state.popup === "error" || this.state.popup === "result") && (
          <Popup
            key="popup"
            text={this.state.popupText}
            buttons={[
              <Button
                className="popup_button"
                onClick={(e) => {
                  this.setState({ popup: "none" });
                  if (this.state.popup === "error") this.back();
                }}
              >
                Ok
              </Button>,
            ]}
            onClickClose={() => {
              this.setState({ popup: "none" });
              if (this.state.popup === "error") this.back();
            }}
          />
        )}
        {this.state.popup === "delete" && (
          <Popup
            key="popup"
            text="Biztosan törli?"
            buttons={[
              <Button
                className="popup_button"
                onClick={() => {
                  this.setState({ popup: "none" });
                  this.delete();
                }}
              >
                Igen
              </Button>,
              <Button
                className="popup_button"
                onClick={(e) => {
                  this.setState({ popup: "none" });
                }}
              >
                Mégse
              </Button>,
            ]}
            onClickClose={() => this.setState({ popup: "none" })}
          />
        )}
      </Frame>
    );
  }
}

export default (props) => (
  <RouteNode nodeName={ROUTE_PALLET_CHECK_DETAILS}>
    {(routeProps) => <PalletCheckDetails {...routeProps} {...props} />}
  </RouteNode>
);
